import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import InternalRedirect from "~/components/Navigation/InternalRedirect/InternalRedirect";
export function SpaceRootRedirect({ spaceId }: {
    spaceId: string;
}) {
    return <InternalRedirect to={links.projectsPage.generateUrl({ spaceId })}/>;
}
